import { isReservationMailPreviewError } from '@/new-transport/_utils/split-reservation-mail-preview/split-reservation-mail-preview';

export const BOARDING_PASS_MISSING_ERROR = 'Reservation has no boarding passes.';

/**
 * Returns reservation IDs from mail preview errors caused by missing boarding passes.
 *
 * @param errors - Mixed array of preview errors from mail preview.
 * @returns Reservation IDs without uploaded boarding passes.
 */
export function getBoardingPassMissingReservationIds(errors: unknown[]): number[] {
	return errors
		.filter(isReservationMailPreviewError)
		.filter((error) => error.error === BOARDING_PASS_MISSING_ERROR)
		.map((error) => error.reservationId);
}
